import template from 'templates/__watchlistFloatingTooltip.tpl';

export default class FloatingTooltip {
    constructor(inMoviePage = false) {
        this._ = null;
        this._tooltipTimeOut = 4500;
        this._resizeHandler = null;
        this.inMoviePage = inMoviePage;
        this.isVisible = false;
        this.initialTopProperty = null;
        this.timeout = null;
        this.elHeader = document.querySelector('header');
        this.elMainContainer = document.querySelector('#main-container');
        this.init();
    }

    init() {
        let tooltipEl = document.createRange().createContextualFragment(template());
        this.elHeader.insertBefore(tooltipEl, this.elHeader.firstElementChild);
        this._ = this.elHeader.firstElementChild;
    }

    setMessage(message) {
        this._.firstElementChild.innerHTML = message;
        return this;
    }

    slideIn(message = null) {
        // If the tooltip isn't visible
        if (!this.isVisible) {
            if (message) {
                this.setMessage(message);
            }

            // Calculate floating tooltip width based on header_wrapper width
            this.setTooltipWidthAndMargins();
            // Calculates floating tooltip top property based on breakpoint
            this.initialTopProperty = this._.style.getPropertyValue('top');
            this.setTooltipTopProperty();

            this._.style.setProperty('visibility', 'visible');
            this.isVisible = true;

            // Reacts actively to window resize
            this._resizeHandler = () => {
                this.setTooltipWidthAndMargins();
                this.setTooltipTopProperty();
            };
            window.addEventListener('resize', this._resizeHandler);

            // Creates timeout to auto-hide tooltip
            this.timeout = this.createTimeout();
        } else {
            this.extendTimeout();
        }
    }

    setTooltipTopProperty() {
        let newTopProperty = '43px';

        // Sets top of floating tooltip based on the movie main-container
        if (this.inMoviePage) {
            if (!this.isHeaderVisible()) {
                newTopProperty = `5px`;
            } else {
                let topOffset = this.elMainContainer.getBoundingClientRect().top + 3;
                newTopProperty = `${topOffset}px`;
            }
        }

        // Sets top property for floating tooltip
        this._.style.setProperty('top', newTopProperty);
    }

    setTooltipWidthAndMargins() {
        let tooltipWidth = this.calculateTooltipWidth();
        let tooltipMarginLeft = this.calculateTooltipLeftMargin();
        this._.style.setProperty('width', `calc(100% - ${tooltipWidth}px)`);
        this._.style.setProperty('margin', `0 ${tooltipMarginLeft}`);
    }

    calculateTooltipWidth() {
        let header = this.elHeader;
        let headerWrap = header.querySelector('.header__wrap');
        let headerCompStyle = window.getComputedStyle(headerWrap);
        let headerPadLeft = headerCompStyle.getPropertyValue('padding-left');
        let tooltipCompStyle = window.getComputedStyle(this._);
        let tooltipPadLeft = tooltipCompStyle.getPropertyValue('padding-left');

        return (parseInt(headerPadLeft) + parseInt(tooltipPadLeft)) * 2;
    }

    calculateTooltipLeftMargin() {
        let header = this.elHeader;
        let headerWrap = header.querySelector('.header__wrap');
        let headerCompStyle = window.getComputedStyle(headerWrap);

        return headerCompStyle.getPropertyValue('padding-left');
    }

    isHeaderVisible() {
        let header = this.elHeader;
        let headerComputedStyle = window.getComputedStyle(header);
        return headerComputedStyle.getPropertyValue('visibility') !== 'hidden';
    }

    createTimeout() {
        let self = this;
        let tooltip = this._;

        return setTimeout(() => {
            tooltip.style.setProperty('top', self.initialTopProperty);
            tooltip.style.removeProperty('visibility');
            this.isVisible = false;
            this.initialTopProperty = null;
            // Removes resize event listener
            window.removeEventListener('resize', this._resizeHandler);
        }, this._tooltipTimeOut);
    }

    extendTimeout() {
        clearTimeout(this.timeout);
        this.createTimeout();
    }
}
